import { render, staticRenderFns } from "./JoinUserCitation.vue?vue&type=template&id=24372854"
import script from "./JoinUserCitation.vue?vue&type=script&lang=js"
export * from "./JoinUserCitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports